import { Divider } from "@mui/material";
import { SideNav } from "components";
import UploadFile from "components/UploadFile";
import {
  LargeButton,
  MainBody,
  PageTitle,
  Ptag,
  OverlayLoader,
} from "components/core";
import routes from "components/routes";
import useLocalData from "hooks/useLocalData";
import { WidthLimiter } from "pages/PlanSetup/styles";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import http from "services/httpService";
import { DisplayName, getFileNameFromUrl } from "utlis/utils";
import { fetchUniversalSetupMasterSelected } from "./schema";
import { HomeWrapper } from "components/CdBalance/style";

const Insurer = () => {
  const navigate = useNavigate();

  const selectedValues = useLocalData("eb_selected_values");
  const userplanId = useLocalData("eb_current_plan");

  const productName = useMemo(() => {
    if (!selectedValues || !userplanId) return;
    const name =
      selectedValues.userplans_data[userplanId].product_type.display_name ||
      selectedValues.userplans_data[userplanId].product_type.product_type_name;
    return DisplayName(name);
  }, [userplanId, selectedValues]);

  const [file, setFile] = useState({
    employer: "",
    employee: "",
  });
  const [fileName, setFileName] = useState({
    employer: null,
    employee: null,
  });
  const [fileError, setFileError] = useState({
    employer: false,
    employee: false,
  });
  const [loading, setLoading] = useState(false);

  // Check if employer file exists (either uploaded or existing)
  const hasEmployerFile = useMemo(() => {
    return !!(file.employer || fileName.employer);
  }, [file.employer, fileName.employer]);

  const handleSubmit = async () => {
    // If both files exist (either uploaded or existing), navigate directly
    if ((fileName.employee || file.employee) && (fileName.employer || file.employer)) {
      navigate(`/${routes.UNIVERSAL_PLAN_SETUP}`);
      return;
    }

    // Check if employer file is missing
    if (!file.employer && !fileName.employer) {
      setFileError((prev) => ({ ...prev, employer: true }));
      return;
    }

    // If only new files are uploaded, make API call
    if (file.employer || file.employee) {
      try {
        setLoading(true);
        const { data } = await http.post("/business/upload_policy_document/", {
          employer_document_id: file.employer,
          employee_document_id: file.employee,
          userplan_id: userplanId,
        });
        navigate(`/${routes.UNIVERSAL_PLAN_SETUP}`);
      } catch (err) {
        console.log({ err });
        setLoading(false);
      }
    } else {
      // If no new files but existing files are present
      navigate(`/${routes.UNIVERSAL_PLAN_SETUP}`);
    }
  };

  useEffect(() => {
    setLoading(true);
    (async function () {
      await fetchUniversalSetupMasterSelected();
    })();
    if (selectedValues) {
      setTimeout(() => {
        const currentProductData = selectedValues.userplans_data[userplanId];
        setFileName({
          employer: getFileNameFromUrl(
            currentProductData["employer_benefit_manual_link"]
          ),
          employee: getFileNameFromUrl(
            currentProductData["employee_benefit_manual_link"]
          ),
        });
        setLoading(false);
      }, 1000);
    }
  }, [selectedValues]);

  return loading ? (
    <OverlayLoader />
  ) : (
    <>
      <SideNav />
      <HomeWrapper style={{}}>
        <PageTitle title={`Setup ${productName}`} />
        <WidthLimiter>
          <Ptag fontSize="20px" fontWeight="bold" marginTop="4rem" fontFamily="Montserrat">
            Upload Coverage Documents
          </Ptag>
          <UploadFile
            label="Policy Schedule for Employer"
            text="Upload PDF"
            format="pdf"
            existingFileName={fileName.employer}
            type="policy_schedule"
            onSelect={(fileId) => {
              setFile((prev) => ({ ...prev, employer: fileId }));
              // Clear error when file is selected
              setFileError((prev) => ({ ...prev, employer: false }));
            }}
            showError={fileError.employer}
          />
          <Divider
            sx={{
              marginTop: "1.8rem",
            }}
          />
          <UploadFile
            label="Benefit Manual for Employees (optional)"
            text="Upload PDF"
            format="pdf"
            type="benifit_manual"
            existingFileName={fileName.employee}
            onSelect={(fileId) =>
              setFile((prev) => ({ ...prev, employee: fileId }))
            }
            // showError={fileError.employee} - commented as this is optional
          />
        
        </WidthLimiter>
        <LargeButton
            type="submit"
            label="Save & Next"
            marginTop="2rem"
            onClick={handleSubmit}
            disabled={!hasEmployerFile || loading}
            style={{
              width: "932px",
              opacity: (hasEmployerFile && !loading) ? 1 : 0.6,
              pointerEvents: (hasEmployerFile && !loading) ? "auto" : "none",
            }}
          />
      </HomeWrapper>
    </>
  );
};

export default Insurer;